const privacySettings = {
  'privacy.leaderboard.section.title': 'Configuración de Clasificación',
  'privacy.leaderboard.opt-in': 'Únete a las Clasificaciones',
  'privacy.leaderboard.opt-in.explanation':
    'Comparte tus mejores puntuaciones con otros jugadores y compara tu rendimiento.',
  'privacy.leaderboard.anonymous': 'Clasificación anónima',
  'privacy.leaderboard.anonymous.explanation': 'Tu nombre y avatar no se compartirán con otros jugadores.',

  'privacy.profile.section.title': 'Configuración de Perfil',
  'privacy.admin-profile.opt-in': 'Compartir datos con administradores',
  'privacy.admin-profile.explanation': 'Comparte tu perfil y datos de entrenamiento con administradores de tus grupos privados.',
  'privacy.admin-profile.note': 'EG: Entrenadores, Padres, etc.',
  'privacy.group-profile.opt-in': 'Compartir datos con grupos',
  'privacy.group-profile.explanation': 'Comparte tu perfil y datos de entrenamiento con jugadores de tus grupos privados.',
  'privacy.public-profile.opt-in': 'Compartir perfil con todos los jugadores',
  'privacy.public-profile.explanation': 'Hace tu perfil visible para otros jugadores fuera de tus grupos.',
  'privacy.public-profile.note': '(Nota: Esto no comparte tus datos de entrenamiento).',

  'privacy.push-notifications.opt-in': 'Notificaciones Push',
  'privacy.push-notifications.explanation': 'Recibe notificaciones sobre tu progreso de entrenamiento y nuevas funciones.',
  'privacy.push-notifications.note': 'Puedes cambiar esta configuración en cualquier momento en la configuración de tu perfil.',
};

export const privacy = {
  ...privacySettings,
};